const numberFilter = value => {
  if (!value && value !== 0) return "";
  value = value.toString();
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const GlobalFilters = {
  install(Vue) {
    Vue.filter("number", numberFilter);
    Vue.filter("formatNumber", function(value) {
      if (typeof value === "string" || value instanceof String) return value;
      return new Intl.NumberFormat("fr-FR").format(value);
    });
  }
};

export default GlobalFilters;
